import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from '../root-route'
import { loginSearchSchema } from '../search'

/**
 * Вне `shellRoute` намеренно: своя страница без шапки, без авторизации по определению.
 *
 * `redirect` в поисковой строке — куда вернуть пользователя после входа; кладёт его `App.tsx`
 * при перехвате 401 (см. `setupHttp`). Значение фильтруется схемой (`../search.ts`): наружу
 * выходит только внутренний путь. Это защита от открытого редиректа, а не придирка к типам —
 * значение уезжает в `redirect_uri`, и gateway отправляет туда браузер уже ПОСЛЕ успешного
 * входа. Не ослаблять.
 */
export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  validateSearch: loginSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/login'), 'LoginPage'),
})
